import JsZip from 'jszip';
import db from 'mime-db';
import saveFile from '../saveFile';

const exportZip = (blobs, title) => {
  const zip = JsZip();
  blobs.forEach((blob, i) => {
    let blobType = blob.type

    if (blobType === 'image/jpg') blobType = 'image/jpeg'
    zip.file(`file-${i}.${db[blobType].extensions[0]}`, blob);
  });
  zip.generateAsync({ type: 'blob' }).then(zipFile => {
    const fileName = `${title}.zip`;

    return saveFile(zipFile, fileName);
  });
};

export default exportZip;
